/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Interact_ScreenInputs */

const en_onboarding_interact_screen = /** @type {(inputs: Onboarding_Interact_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read on screen`)
};

const es_onboarding_interact_screen = /** @type {(inputs: Onboarding_Interact_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo en pantalla`)
};

/**
* | output |
* | --- |
* | "Read on screen" |
*
* @param {Onboarding_Interact_ScreenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_interact_screen = /** @type {((inputs?: Onboarding_Interact_ScreenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Interact_ScreenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_interact_screen(inputs)
	return en_onboarding_interact_screen(inputs)
});